import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAutocomplete,_vm._b({attrs:{"dense":"","outlined":"","label":_vm.$t('Sort direction'),"items":_vm.sortDirectionItems,"hide-details":"auto"},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.$t(item.text)))])]}},{key:"item",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.$t(item.text)))])]}}]),model:{value:(_vm.sortDirection),callback:function ($$v) {_vm.sortDirection=$$v},expression:"sortDirection"}},'v-autocomplete',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }